import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { IPD_COLORS } from './ipdColors';

export default function IpdPageHeader({ eyebrow, title, description, descriptionTrailing, badge, actions }) {
  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      mb: 2.5,
      flexWrap: 'wrap',
      gap: 2,
    }}>
      <Box sx={{ minWidth: 0 }}>
        {eyebrow && (
          <Typography sx={{
            fontSize: 12,
            color: IPD_COLORS.textSecondary,
            mb: 0.5,
            fontWeight: 500,
          }}>
            {eyebrow}
          </Typography>
        )}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
          <Typography
            component="h1"
            sx={{
              color: IPD_COLORS.textPrimary,
              fontWeight: 700,
              fontSize: { xs: 22, sm: 26 },
              lineHeight: 1.2,
              letterSpacing: '-0.02em',
            }}
          >
            {title}
          </Typography>
          {badge != null && (
            <Chip
              label={badge}
              size="small"
              sx={{
                height: 24,
                fontWeight: 600,
                fontSize: 12,
                backgroundColor: IPD_COLORS.selectedBg,
                color: IPD_COLORS.primary,
                border: `1px solid ${IPD_COLORS.border}`,
              }}
            />
          )}
        </Box>
        {(description || descriptionTrailing) && (
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2,
            mt: badge != null ? 0.5 : 0.75,
            flexWrap: 'wrap',
          }}>
            {description && (
              <Typography sx={{ color: IPD_COLORS.textSecondary, fontSize: 14, lineHeight: 1.5 }}>
                {description}
              </Typography>
            )}
            {descriptionTrailing}
          </Box>
        )}
      </Box>
      {actions && (
        <Box sx={{ display: 'flex', gap: 1, flexShrink: 0, alignItems: 'center' }}>
          {actions}
        </Box>
      )}
    </Box>
  );
}
